export enum PlanType {
  INDIVIDUAL = 'INDIVIDUAL',
  GROUP = 'GROUP',
}

export const PLAN_TYPE_LABELS: Record<PlanType, string> = {
  [PlanType.INDIVIDUAL]: 'Individual',
  [PlanType.GROUP]: 'Grupal',
};
